import { Inject, Injectable, EventEmitter } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { APP_CONFIG, IAppConfig } from '../../shared/config/app.config';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {SapConfig} from './sap.config';

/**
 * Office service for all the office related api call
 */
@Injectable()
export class ConfigService {

  public isLoggedIn$: EventEmitter<boolean>;
  public arpUsap: any;
  public arpOrigin: any;
  private config: any;
  private env: any;

  constructor(
    @Inject(APP_CONFIG) private appConfig: IAppConfig,
    private logger: NGXLogger,
    private http: HttpClient
    ) {
    // constructor
    this.isLoggedIn$ = new EventEmitter();
  }

  public setConfigData(key: string, value: any) {
    this.appConfig[key] = value;
  }

  public getConfigData(key: string): any {
    if (this.appConfig && this.appConfig[key]) {
      return this.appConfig[key];
    }
    return null;
  }
  /**
   * Use to get the data found in the second file (config file)
   */
  public getConfig(key: any) {
    if (this.config && this.config[key]) {
      return this.config[key];
    }
  }

  /**
   * Use to get the data found in the first file (env file)
   */
  public getEnv() {
    return this.env;
  }

  public isLoggedIn(value: boolean) {
    this.isLoggedIn$.emit(value);
  }

  public getOffUsap(){
    let usap = '';
    let phase = this.guessPhaseFromLocation();
    usap = SapConfig.usap['DEFAULT_OFF'] + SapConfig.getPhaseLetter(phase); 
    return usap;
  }

  public getTpaUsap(){
    let usap = '';
    let phase = this.guessPhaseFromLocation();
    usap = SapConfig.usap['DEFAULT_TPA'] + SapConfig.getPhaseLetter(phase);
    return usap;
  }

  guessPhaseFromLocation(): string {
    let phase = 'usr';  // default phase
    let host = location.host;
    if (host.startsWith('www.')) {
      host = host.substring(4);
    }
    if (host.endsWith('amadeus.com')) {
      const chunks = host.split('.');
      if (chunks.length > 0) {
        phase = (chunks[0] === 'office-management') ? 'prd' : chunks[0];
      }
    }
    if (host.startsWith('ngeum')) {
      phase = 'USR'
    }
    return phase;
  }

  /**
   * This method:
   *   a) Get env from token
   *   b) Loads "config.json" to get all env's variables
   *   (e.g.: 'config.json')
   */
  public load() {
    return new Promise((resolve, reject) => {
      let envResponse: any = null;
      if (!envResponse) {
        if (this.appConfig.env[location.hostname]) {
          envResponse = this.appConfig.env[location.hostname];
        }
      }
      envResponse = envResponse ? envResponse.toLowerCase() : 'dev';
      this.env = envResponse;
      let request: any = this.http.get('assets/config/config.json');

      if (request) {
        request.pipe(
        catchError((error: any) => {
          this.logger.error('Error reading  configuration file');
          resolve(error);
          let retError  = null;
          try {
            if (error && error && error.error) {
              retError = error.error;
            }
          } catch (e) {
            // some error
          }
          return throwError(retError || 'Server error');
      })
        ).subscribe((responseData) => {
            if (responseData && responseData.data) {
              this.setConfig(responseData.data);
            }
            resolve(true);
          });
      } else {
        this.logger.error('Env config (' + envResponse + ') is not valid');
        resolve(true);
      }
    });
  }

  private setConfig(value) {
    this.config = value;
  }
}